__turbopack_context__.v({
  "agreementBlock": "AgreementBlock-module-scss-module__pJYmRq__agreementBlock",
});
